import { useEffect } from "react";
import { useContext } from "react";
import { createContext, useState } from "react";
import { getActiveCollaborationByInfluencer, getNotActiveCollaborationByInfluencer, getActiveCollaborationByCompany, getNotActiveCollaborationByCompany, getRatePendingInfluencer, getRatePendingCompany } from "../api/collaborationApi";
import { UserContext } from "./userContext";


export const CollaborationsContext = createContext();

export default function CollaborationsProvider({ children }) {

    const { id, userType } = useContext(UserContext);
    const [activeCollaborations, setActiveCollaborations] = useState([]);
    const [notActiveCollaborations, setNotActiveCollaborations] = useState([]);
    const [collaborationNotificationCount, setCollaborationNotificationCount] = useState(0);

    const [ratePending, setRatePending] = useState([/* {
        image: "https://vinusimages.co/wp-content/uploads/2018/10/EG7A2390.jpgA_.jpg",
        name: "Sara",
        id: 9
    }, {
        image: "https://www.whatsappimages.in/wp-content/uploads/2021/07/Top-HD-sad-quotes-for-whatsapp-status-in-hindi-Pics-Images-Download-Free.gif",
        name: "Juan",
        id: 9
    } */]);

    useEffect(() => {

        if (id !== null) {
            if (userType === 'influencer') {
                getActiveCollaborationByInfluencer({ influencerId: id }).then((response) => {
                    setActiveCollaborations(response)
                    let suma = 0
                    for (let i = 0; i < response.length; i++) {
                        if (response[i].readinfluencer === false) {
                            suma += 1
                        }
                    }
                    setCollaborationNotificationCount(suma);

                })
                getNotActiveCollaborationByInfluencer({ influencerId: id }).then((response) => {
                    setNotActiveCollaborations(response)
                })

                getRatePendingInfluencer({ influencerId: id }).then((response) => {
                    setRatePending(response)
                })

            } else {
                getActiveCollaborationByCompany({ companyId: id }).then((response) => {
                    setActiveCollaborations(response)
                    let suma = 0

                    for (let i = 0; i < response.length; i++) {
                        if (response[i].readcompany === false) {
                            suma += 1;
                        }
                    }

                    setCollaborationNotificationCount(suma);
                })
                getNotActiveCollaborationByCompany({ companyId: id }).then((response) => {
                    setNotActiveCollaborations(response)
                })
                getRatePendingCompany({ companyId: id }).then((response) => {
                    setRatePending(response)
                })
            }

        }
    }, [id])

    return (
        <CollaborationsContext.Provider value={{ activeCollaborations, setActiveCollaborations, notActiveCollaborations, setNotActiveCollaborations, collaborationNotificationCount, setCollaborationNotificationCount, ratePending, setRatePending }}>
            {children}
        </CollaborationsContext.Provider >
    )

};